import { render, staticRenderFns } from "./_affiliateList.vue?vue&type=template&id=8d43cc7e&lang=pug"
import script from "./_affiliateList.vue?vue&type=script&lang=js"
export * from "./_affiliateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports